import { useState } from 'react'
import type { FocusEvent } from 'react'

export const useHover = () => {
  const [isHovered, setIsHovered] = useState(false)

  return {
    isHovered,
    hoverProps: {
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      onFocus: () => setIsHovered(true),
      onBlur: (event: FocusEvent<HTMLElement>) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
          setIsHovered(false)
        }
      }
    }
  }
}
